import React from "react";

function LineEditDropdownCell({ displayLabel, disabled = false, isLoading = false, onClick }) {
    const handleClick = e => {
        if (disabled || isLoading) return;
        onClick?.(e);
    };

    const handleKeyDown = e => {
        if (disabled || isLoading) return;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick?.(e);
        }
    };

    return (
        <div
            className={`line-edit-dd-cell${disabled ? " disabled" : ""}${isLoading ? " loading" : ""}`}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={disabled || isLoading ? -1 : 0}
            aria-busy={isLoading || undefined}
        >
            <span className={`line-edit-dd-cell__label${!displayLabel ? " placeholder" : ""}`}>{displayLabel || "Select"}</span>
            {isLoading ? <span className="line-edit-dd-cell__spinner" aria-hidden="true" /> : <span className="line-edit-dd-cell__caret" aria-hidden="true" />}
        </div>
    );
}

export default React.memo(LineEditDropdownCell);
